export class Config {
  static REACT_APP_NODE_ENV = window.REACT_APP_NODE_ENV;
  static REACT_APP_URL = window.REACT_APP_URL;
  static REACT_APP_BACKEND_URL = window.REACT_APP_BACKEND_URL;

  // Signoz configuration
  static REACT_APP_SIGNOZ_TRACE_SAMPLE_RATE =
    window.REACT_APP_SIGNOZ_TRACE_SAMPLE_RATE;
  static REACT_APP_SIGNOZ_SERVICE_NAME = window.REACT_APP_SIGNOZ_SERVICE_NAME;
  static REACT_APP_SIGNOZ_SERVICE_VERSION =
    window.REACT_APP_SIGNOZ_SERVICE_VERSION;
  static REACT_APP_SIGNOZ_ENV = window.REACT_APP_SIGNOZ_ENV;
  static REACT_APP_SIGNOZ_SERVICE_NAMESPACE =
    window.REACT_APP_SIGNOZ_SERVICE_NAMESPACE;
  static REACT_APP_SIGNOZ_URL = window.REACT_APP_SIGNOZ_URL;
  static REACT_APP_SIGNOZ_ALLOWED_ORIGINS =
    window.REACT_APP_SIGNOZ_ALLOWED_ORIGINS;

  // Encryption keys
  static REACT_APP_ENCRYPT_KEY_TOKEN = window.REACT_APP_ENCRYPT_KEY_TOKEN;
  static REACT_APP_ENCRYPT_KEY_REFRESH_TOKEN =
    window.REACT_APP_ENCRYPT_KEY_REFRESH_TOKEN;
  static REACT_APP_ENCRYPT_KEY_EMAIL = window.REACT_APP_ENCRYPT_KEY_EMAIL;
  static REACT_APP_ENCRYPT_KEY_ROLE = window.REACT_APP_ENCRYPT_KEY_ROLE;
  static REACT_APP_ENCRYPT_KEY_USER = window.REACT_APP_ENCRYPT_KEY_USER;
  static REACT_APP_ENCRYPT_KEY_MENUS = window.REACT_APP_ENCRYPT_KEY_MENUS;
  static REACT_APP_ENCRYPT_KEY_COMPANY = window.REACT_APP_ENCRYPT_KEY_COMPANY;
}
